const createAddItemInArray = stateValue => {
  return (state, action) => {
    return {
      ...state,
      [stateValue]: [...state[stateValue], action.payload.data],
    };
  };
};

export default createAddItemInArray;



// WEBPACK FOOTER //
// src/redux/reducers/functions/createAddItemInArray.js